export default function() {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  
  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
      , detectIpad: IPADDETECTED
      // options
      , allEventsLink: true
      , allEventsLinkText: 'VIEW FULL CALENDAR'
      , hasImages: false
      , imageBackground: false
      , lazyLoadImages: false
      , buyNowButton: {visible: false, text: 'BUY NOW'}
      , moreButton: {visible: false, text: 'MORE'}
      , maxItemsVisible: 5
      , isResponsive: false
      , hasDescription: false
      , textContainer: true
      , link: 'all' //options are 'all', 'text', 'image', 'imageAndText', or ''
      , attributeOrder: {
        1: 'title',
        2: 'date',
        3: 'image',
        4: 'description',
        5: 'buttons'
      }
      , multiFeatureLoaded: function(data){
        $('.all-events-btn').addClass('button');
      }
  });

};

